<template>
    <div>
        <div class="ibox form">
            <div class="ibox-title ibox-grey">
                <h4>{{ __("notes") }}</h4>
            </div>
            <div class="ibox-content">
                <notes-table
                    :notes="filteredNotes"
                    :toggle-route="toggleRoute"
                    :preview="preview"
                />

                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-primary"
                            @click.prevent="openCreateModal"
                            v-if="!preview"
                        >
                            <i class="fa fa-plus"></i> {{ __("add_a_note") }}
                        </button>
                    </div>
                    <div class="col-6 text-right">
                        <label
                            ><input
                                ref="toogle_visibility_checkbox"
                                type="checkbox"
                                v-model="showHidden"
                            />
                            {{ __("show_hidden") }}</label
                        >
                    </div>
                </div>
            </div>
        </div>
        <modal-note-create
            ref="note_create_modal"
            id="note_create_modal"
            :title="__('create_note')"
            :action="storeRoute"
            :old-values="createOld"
            :errors="errors"
            v-if="!preview"
        />
    </div>
</template>

<script>
import ModalNoteCreate from "../../components/modals/ModalNoteCreate.vue";
import NotesTable from "../../components/tables/client/NotesTable.vue";

export default {
    components: { NotesTable, ModalNoteCreate },
    data() {
        return {
            showHidden: false,
            btnDisabled: false
        };
    },
    props: {
        notes: {
            type: Array,
            default: () => []
        },
        storeRoute: {
            type: String,
            default: ""
        },
        toggleRoute: {
            type: String,
            default: ""
        },
        createOld: {
            type: Object,
            default: () => {}
        },
        errors: {
            type: Object,
            default: () => {}
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        filteredNotes() {
            if (!this.showHidden) {
                return this.notes.filter(note => !note.hidden);
            }

            return this.notes;
        }
    },
    methods: {
        openCreateModal() {
            this.$refs.note_create_modal.openModal();
        }
    }
};
</script>

<style lang="scss" scoped></style>
